import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getAudioDetails, getAudios } from "./action";

export const audioEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = audioEntityAdapter.getInitialState({
  count: 0,
  modals: {},
});
export const audioSlice = createSlice({
  name: "audio",
  initialState: initialState,
  reducers: {
    showAudioDeleteModal: (state, action) => {
      state.modals.audioDeleteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAudios.fulfilled, (state, action) => {
      if (action.payload.success) {
        audioEntityAdapter.setAll(state, action.payload.data);
        state.count = action.payload.totalLength;
      }
    });
    builder.addCase(getAudioDetails.fulfilled, (state, action) => {
      if (action.payload.success) {
        audioEntityAdapter.setOne(state, action.payload.data);
      }
    });
  },
});

export const { showAudioDeleteModal } = audioSlice.actions;

export default audioSlice.reducer;
